var _g, _g2, _g3, _path, _path2, _path3, _path4, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleTrexClone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 40,
    rx: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: -15,
    width: 16,
    height: 20,
    rx: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: -5,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 10,
    width: 8,
    height: 12,
    rx: 2,
    fill: "black",
    transform: "rotate(-15)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 38,
    width: 8,
    height: 20,
    rx: 1,
    fill: "black",
    transform: "rotate(-15)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 8,
    height: 16,
    rx: 1,
    fill: "black",
    transform: "rotate(15)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(220, 240)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 4,
    height: 40,
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 0,
    width: 4,
    height: 40,
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 24,
    height: 4,
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25,
    width: 24,
    height: 4,
    fill: "#3B82F6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 4,
    height: 30,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 0,
    width: 4,
    height: 30,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8,
    width: 20,
    height: 4,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 20,
    height: 4,
    fill: "#EF4444"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 280 L320 280",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 284 C 140 288, 200 282, 260 286, 290 288, 320 284",
    stroke: "black",
    strokeWidth: 1,
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 160 C 130 150, 160 170, 190 160",
    stroke: "black",
    strokeWidth: 2,
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220 140 C 250 130, 280 150, 310 140",
    stroke: "black",
    strokeWidth: 2,
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 200,
    r: 3,
    fill: "#3B82F6",
    opacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 180,
    r: 3,
    fill: "#EF4444",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 160,
    r: 3,
    fill: "black",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTrexClone);
export default __webpack_public_path__ + "static/media/google-trex-clone.2246a6d67876360585136dbc00deb8f8.svg";
export { ForwardRef as ReactComponent };